import { authHeader, isTokenExpired } from "../helpers";

export const myThemesServices = {
  getThemes,
  createOrUpdateTheme,
  deleteTheme,
};

function getThemes() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(true),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/themes`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

async function createOrUpdateTheme(
  data,
  soundFile = null,
  soundName = "",
  imageFile = null,
  imageName = "",
  isCreation = true
) {
  console.log("isCreation", isCreation);
  const formData = new FormData();
  let soundBlob, imageBlob;

  if (typeof soundFile === "string") {
    // If soundFile is a string URL, fetch it and create a Blob
    try {
      const response = await fetch(soundFile);
      soundBlob = await response.blob();
    } catch (error) {
      console.error("Error converting sound URL to Blob:", error);
      return Promise.reject("Failed to process sound file");
    }
  }

  if (typeof imageFile === "string") {
    // Similar handling for image URLs
    try {
      const response = await fetch(imageFile);
      imageBlob = await response.blob();
    } catch (error) {
      console.error("Error converting image URL to Blob:", error);
      return Promise.reject("Failed to process image file");
    }
  }

  if (soundFile)
    formData.append("sound", soundBlob, soundName.replaceAll(" ", ""));
  if (imageFile)
    formData.append("image", imageBlob, imageName.replaceAll(" ", ""));
  formData.append("theme", JSON.stringify(data));

  const requestOptions = {
    method: isCreation ? "POST" : "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/themes${
    isCreation ? "" : `/${data._id}`
  }`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteTheme(themeId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/themes/${themeId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(async (res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        let tmp = await res.json();
        const error = (tmp && tmp.reason) || tmp.statusText;
        return Promise.reject(error);
      }
    });
}
